<h1>Historique des transferts de responsabilité de CAC / CC</h1>
<pannel [title]="'Résultat de la recherche'" [expandable]="true" [folded]="false">
  <div class="mat-elevation-z8">
	<table class="histo" mat-table [dataSource]="dataSource" matSort>

	    <ng-container matColumnDef="id">
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ simplifiedTransfert.data.id }}</td>
	    </ng-container>
	
	    <ng-container matColumnDef="date" >
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date de mise à jour</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert"> {{ simplifiedTransfert.data.dateTransfert  | localDateTimeToDate: false | date : 'dd/MM/yyyy HH:mm' }}</td>
	    </ng-container>
	
	    <ng-container matColumnDef="emetteur">
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Emetteur</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ simplifiedTransfert.emetteur }}</td>
	    </ng-container>
	
	    <ng-container matColumnDef="destinataire">
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinataire</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ simplifiedTransfert.destinataire }}</td>
	    </ng-container>
	
	    <ng-container matColumnDef="cac">
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>CAC</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ simplifiedTransfert.data.responsabilite }}</td>
	    </ng-container>
	
<!-- 	    <ng-container matColumnDef="type"> -->
<!-- 	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th> -->
<!-- 	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ simplifiedTransfert.type ? 'Local' : 'Distant' }}</td> -->
<!-- 	    </ng-container> -->
	
	    <ng-container matColumnDef="etat">
	      <th mat-header-cell *matHeaderCellDef mat-sort-header>Etat</th>
	      <td mat-cell *matCellDef="let simplifiedTransfert">{{ possibleEtats[simplifiedTransfert.data.etat-1] }}</td>
	    </ng-container>

		<ng-container matColumnDef="perimetre">
	  		<th mat-header-cell *matHeaderCellDef >Périmètre</th>
			<td mat-cell *matCellDef="let simplifiedTransfert">
				<div class="perimetre-container">
					<div *ngIf="simplifiedTransfert.antennesCompletes?.length">
						<span>Antenne complète&nbsp;: <b>{{ simplifiedTransfert.antennesCompletes }}</b></span>
					</div>

					<div *ngIf="!simplifiedTransfert.antennesCompletes?.length">
					
						<div *ngIf="simplifiedTransfert.parcsComplets?.length">
							<span>Parc(s) complet(s)&nbsp;: </span>
							<div class="inline-item"><b>{{ simplifiedTransfert.parcsCompletCodes }}</b></div>
						</div>

						<div *ngIf="simplifiedTransfert.parcsIncomplets?.length">
							<span>Ouvrage(s)&nbsp;: </span>
							<div class="parc-container">
								<div *ngFor="let parc of simplifiedTransfert.parcsIncomplets" class="parc-wrapper">
									<b>{{ parc.code }}</b>: <span class="inline-item">{{ parc.ouvrageCodes }}</span>
									<div class="sousParc" *ngFor="let sousParc of parc.sousParcs">
										- <b>{{ sousParc.code }}</b>&nbsp;:
										<div class="inline-items">
											<span class="inline-item">{{ sousParc.ouvrageCodes }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</td>
		</ng-container> 

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

	</table>

    <mat-paginator #paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20, 50]" 
      [pageSize]="10" aria-label="Choisissez une page">
    </mat-paginator>
  </div>
  
  <nav class="navbar footer">
	<div class="navbar navbar-left">
		<button class="btn btn-primary" (click)="exportRequests$.next()">Exporter</button>
	</div>
  </nav>
</pannel>



 